(function () {
  var INSURANCE_VARIANT_ID = 45794067022003;
  var INSURANCE_SKU        = 'ECL-INSURANCE';
  var syncing = false;

  function syncInsurance() {
    if (!INSURANCE_VARIANT_ID || syncing) return;
    syncing = true;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var insuranceItem = null;
        var otherTotal = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.sku === INSURANCE_SKU) {
            insuranceItem = item;
          } else {
            otherTotal += item.final_line_price;
          }
        }

        if (otherTotal > 0 && !insuranceItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: INSURANCE_VARIANT_ID, quantity: 1 }] })
          }).then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        } else if (otherTotal === 0 && insuranceItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: INSURANCE_VARIANT_ID, quantity: 0 })
          }).then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      })
      .catch(function(e) { console.error('[ECL Insurance]', e); })
      .then(function() { syncing = false; });
  }

  document.addEventListener('DOMContentLoaded', syncInsurance);
  document.addEventListener('cart:refresh', syncInsurance);
  document.addEventListener('cart:updated', syncInsurance);

  var _fetch = window.fetch;
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    var isInsuranceCall = url.indexOf(String(INSURANCE_VARIANT_ID)) !== -1;
    var result = _fetch.apply(this, args);
    if (isCartMutation && !isInsuranceCall) {
      result.then(function() { setTimeout(syncInsurance, 300); });
    }
    return result;
  };
})();